export default "__VITE_ASSET__a520eb58__"